export const COLORS = {
  ACTIVE_CIRCLE_COLOR: 'red',
  INACTIVE_CIRCLE_COLOR: 'white',
  CONNECT_FROM_COLOR: 'orange',
};
